const updateHash = (highlight) => {
  document.location.hash = `highlight-${highlight.id}`;
};

// Função para detectar e converter links em texto
const linkifyText = (text) => {
  if (!text) return text;
  
  // Regex para detectar URLs (incluindo http, https, www e domínios simples)
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+|[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\/[^\s]*)?)/g;
  
  const parts = text.split(urlRegex);
  
  return parts.map((part, index) => {
    if (urlRegex.test(part)) {
      // Garantir que o link tem protocolo
      let url = part;
      if (!part.startsWith('http://') && !part.startsWith('https://')) {
        url = 'https://' + part;
      }
      
      return (
        <a 
          key={index}
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          style={{
            color: '#007bff',
            textDecoration: 'underline',
            cursor: 'pointer'
          }}
          onClick={(e) => e.stopPropagation()} // Evitar que o clique no link interfira com outros eventos
        >
          {part}
        </a>
      );
    }
    return part;
  });
};

export function Sidebar({ highlights, removerItem, tipo, itemsParaRemover = [] }) {


  const getNomeCompetencia = (competencia) => {

    if(competencia == 1){
      return tipo != 1 ? `Competência ${competencia}` : `Modalidade culta da língua`;
    }else if(competencia == 2){
      return tipo != 1 ? `Competência ${competencia}` : `Tipologia textual`;
    }else if(competencia == 3){
      return tipo != 1 ? `Competência ${competencia}` : `Argumentação`;
    }else if(competencia == 4){
      return tipo != 1 ? `Competência ${competencia}` : `Coesão e Estrura do período`;
    }else if(competencia == 5){
      return tipo != 1 ? `Competência ${competencia}` : `Adequação ao tema`;
    }else{
      return 'Observação';
    }
  }

  return (
    <div className="sidebar" style={{ 
      width: "100%", 
      height: "calc(100vh - 250px)", // Aumentado de 330px para 250px
      overflowY: "hidden",
      borderRadius: "8px",
      backgroundColor: "#fff",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 1px 4px rgba(0,0,0,0.08)"
    }}>
      <div className="description" style={{ 
        padding: "8px 15px", // Reduzido de 12px para 8px
        borderBottom: "2px solid #eaeaea", 
        backgroundColor: "#f8f9fa",
        borderRadius: "8px 8px 0 0",
        position: "sticky",
        top: 0,
        zIndex: 10,
        flexShrink: 0 // Evitar que encolha
      }}>
        <p style={{ 
          marginBottom: "0.5rem", 
          fontSize: "14px", 
          fontWeight: "500" 
        }}>
          Todos os pontos da correção serão mostrados abaixo
        </p>
        {itemsParaRemover.length > 0 && (
          <div style={{ 
            color: '#ff5555', 
            fontSize: '11px', // Menor
            marginTop: '6px', // Menor
            marginBottom: '4px', // Menor
            padding: '4px 8px', // Mais compacto
            backgroundColor: 'rgba(255,0,0,0.05)',
            borderRadius: '3px', // Menor
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '4px'
          }}>
            <span style={{ fontWeight: '500' }}>
              {itemsParaRemover.length} item(s) para exclusão
            </span>
            <span style={{ fontSize: '9px', opacity: 0.8, fontStyle: 'italic' }}>
              💡 Clique ↶ para cancelar
            </span>
          </div>
        )}
      </div>

      <ul className="sidebar__highlights" style={{ 
        listStyle: "none", 
        padding: "8px", // Reduzido de 10px para 8px
        margin: 0,
        overflowY: "auto",
        flex: 1,
        // Altura dinâmica: se há itens para remover, compensa o espaço da mensagem
        height: itemsParaRemover.length > 0 ? "calc(100% - 85px)" : "calc(100% - 50px)"
      }}>
        {highlights.map((highlight, index) => {
          // Verificar se o item está marcado para remoção
          const marcadoParaRemover = 
            highlight.marcadoParaRemocao || 
            itemsParaRemover.includes(String(highlight.id));
          
          return (
            <li
              key={index}
              className={`sidebar__highlight competencia_${highlight?.competencia}`}
              style={{
                ...marcadoParaRemover ? {
                  opacity: 0.5, 
                  textDecoration: 'line-through',
                  backgroundColor: 'rgba(255, 0, 0, 0.1)'
                } : {},
                margin: "0.5rem 0.4rem", // Reduzido margem
                padding: "0.6rem 0.8rem", // Reduzido padding
                borderRadius: "6px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
                transition: "all 0.2s ease",
                position: "relative"
              }}
            >
              <div>
                <button
                  onClick={(e) => {
                    if (highlight.id === undefined || highlight.id === null) {
                      console.error("Tentando remover item sem ID válido");
                      e.preventDefault();
                      return;
                    }
                    
                    // NOVA FUNCIONALIDADE: Sempre permitir clique para alternar entre marcar/cancelar remoção
                    console.log("Clicando para alternar remoção do item:", highlight.id, "tipo:", typeof highlight.id);
                    removerItem(highlight.id);
                  }}
                  className="ir-direita"
                  title={
                    !highlight.id ? "Item sem ID, não pode ser removido" :
                    marcadoParaRemover ? "Clique para CANCELAR a remoção" :
                    `Clique para MARCAR para remoção: #${highlight.id}`
                  }
                  disabled={!highlight.id}
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "10px",
                    border: "none",
                    borderRadius: "50%",
                    width: "24px",
                    height: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "12px",
                    fontWeight: "bold",
                    cursor: highlight.id ? "pointer" : "not-allowed",
                    backgroundColor: marcadoParaRemover ? "#ffebee" : "#f8f8f8",
                    color: marcadoParaRemover ? "#d32f2f" : "#333",
                    border: marcadoParaRemover ? "1px solid #ffcdd2" : "1px solid #e0e0e0",
                    opacity: highlight.id ? 1 : 0.3,
                    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                    transition: "all 0.2s ease"
                  }}
                >
                  {marcadoParaRemover ? "↶" : "✕"}
                </button>
                
                <div style={{ marginRight: "20px" }}>
                  <strong style={{ 
                    display: "block", 
                    marginBottom: "6px",
                    fontSize: "14px"
                  }}>
                    {highlight?.competencia === 0
                      ? "Salvando informação"
                      : getNomeCompetencia(highlight?.competencia)
                    }:
                    <span style={{ 
                      display: "inline-block", 
                      marginLeft: "4px",
                      fontWeight: "normal"
                    }}>
                      {linkifyText(highlight.comment.text.replace("undefined ", ""))}
                    </span>
                  </strong>
                  
                  <small style={{ 
                    display: "block", 
                    fontSize: "10px", 
                    color: "#999",
                    marginTop: "4px",
                    marginBottom: "6px"
                  }}>
                    ID: {highlight.id}
                    {marcadoParaRemover && <span style={{color: '#ff5555'}}> (marcado para remoção)</span>}
                  </small>
                </div>
                
                {highlight.content.text ? (
                  <blockquote style={{ 
                    marginTop: "0.6rem",
                    padding: "8px 12px",
                    borderLeft: "3px solid #eaeaea",
                    backgroundColor: "#f9f9f9",
                    borderRadius: "0 4px 4px 0",
                    fontSize: "13px",
                    lineHeight: "1.4"
                  }}>
                    {`${highlight.content.text.slice(0, 90).trim()}…`}
                  </blockquote>
                ) : null}
                
                {highlight.content.image ? (
                  <div
                    className="highlight__image"
                    style={{ 
                      marginTop: "0.8rem",
                      borderRadius: "4px",
                      overflow: "hidden",
                      border: "1px solid #eaeaea"
                    }}
                  >
                    <img 
                      src={highlight.content.image} 
                      alt={"Screenshot"} 
                      style={{ 
                        maxWidth: "100%", 
                        display: "block" 
                      }}
                    />
                  </div>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
